function renderRadioInput (country, field) {
  let values = ''
  $.each(field.values, function (i, value) {
    values += `<label class="radio">
        <input type="radio" value="${value.value}" name="${field.name}" data-required data-hj-whitelist>
        <span>${value.label}</span>
      </label>`
  });
  return `<div class="ui-form__row ui-form__row_radio ${(field.rowclass) ? field.rowclass : ''} ${field.hidden ? 'hidden' : ''} columnfield_">
    <div class="ui-form__field">
      ${(field.name === 'has_other_loans' && !window.interface_v2) ? `<div style="font-size: 12px;font-weight: 300;margin-bottom: -20px">${fields_json.params.for_fields.has_other_loans_hint}</div>` : ''}
      ${(field.name === 'other_loans_additional' && !window.interface_v2) ? `<div style="font-size: 12px;font-weight: 300;margin-bottom: -20px">${fields_json.params.for_fields.other_loans_additional_hint}</div>` : ''}
      <div class="ui-radio-directive">
        <span class="ui-radio__text-wrapper">
          ${field.label}
          ${ (window.interface_v2 && field.name === 'has_other_loans') ? fields_json.params.for_fields.has_other_loans_hint : '' }
          ${ (window.interface_v2 && field.name === 'other_loans_additional') ? fields_json.params.for_fields.other_loans_additional_hint : '' }
        </span>
        ${values}
      </div>
      ${(field.name === 'asnef') ? `<div style="font-size: 12px;font-weight: 300;margin-top: 10px">${fields_json.params.for_fields.asnef_hint}</div>` : ''}
      ${(field.name === 'has_car' && country.is_ES) ? '<div style="font-size: 12px;font-weight: 300;margin-top: 10px">Te conseguimos un préstamo incluso sin el aval de tu coche</div>' : ''}
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">${field.error}</div>
    </div>
  </div>`
}

export { renderRadioInput }